import React from 'react';

import PlaceholderAvatar from './placeholder-avatar';
import PlaceholderDisplayName from './placeholder-display-name';

/** Fake account to display while data is loading. */
const PlaceholderAccount: React.FC = React.memo(() => (
  <div className='account--placeholder'>
    <div className='account--placeholder__avatar'>
      <PlaceholderAvatar size={42} />
    </div>

    <div className='account--placeholder__name'>
      <PlaceholderDisplayName minLength={3} maxLength={25} />
    </div>
  </div>
));

PlaceholderAccount.displayName = 'PlaceholderAccount';

export { PlaceholderAccount as default };
